// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"64915cb5","126":"318cbb8d","132":"c702d4c7","655":"56d4994e"}[chunkId] + ".chunk.css";
};